/* app/js/src/components/common/live-broadcast-link/live-broadcast-link.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  width: 100%;
  height: 100%;
  display: block;
}
.container {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.container .label {
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.125rem;
  text-transform: uppercase;
}
.container .counter {
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
}
.container .channel-name {
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 5px;
}
.container.live {
  background-color: #ef5d5d;
}
.container.live .label {
  color: #fff;
}
.container.pre-live {
  background-color: #3d4853;
}
.container.pre-live .label {
  color: rgba(255, 255, 255, 0.4);
}
.container.pre-live .counter,
.container.pre-live .channel-name {
  color: #fff;
}
.container.off {
  background-color: #3d4853;
}
.container.off .label {
  color: rgba(255, 255, 255, 0.4);
}
.container.off .channel-name {
  color: rgba(255, 255, 255, 0.7);
}
/*# sourceMappingURL=live-broadcast-link.component.css.map */
